module.exports = __webpack_public_path__ + "img/assign-track-icon.4bff65ff.svg";